import { ListItem } from 'types/TextSearch';
import { MakesAndModelsResponse } from 'types/MakesAndModelsResponse';
import { BODY_STYLES, FEATURED_TRIMS } from './constants';

class TextSearchList {
  list: ListItem[];

  constructor(makesAndModels: MakesAndModelsResponse[]) {
    const makeList = makesAndModels.map((make) => ({
      displayName: make.name,
      make: make.name,
      searchParams: { make: make.name },
      queryArray: [make.name],
      iconClass: make.name,
    }));

    const modelList: ListItem[] = [];
    makesAndModels.forEach((make) =>
      make.models.forEach((model) =>
        modelList.push({
          displayName: `${make.name} ${model.name}`,
          make: make.name,
          model: model.name,
          searchParams: { make: make.name, model: model.name },
          queryArray: [`${make.name} ${model.name}`, make.name, model.name],
          iconClass: make.name,
        })
      )
    );

    this.list = [...BODY_STYLES, ...makeList, ...modelList, ...FEATURED_TRIMS];
  }

  filter(query: string): ListItem[] {
    if (this.list.length === 0 || query === '') {
      return [];
    }

    const filteredList: ListItem[] = this.list
      .filter((listItem: ListItem) =>
        listItem.queryArray.some((name) =>
          name.toLowerCase().startsWith(query.trim().toLowerCase())
        )
      )
      .slice(0, 20);

    return filteredList;
  }
}

export default TextSearchList;
